<template>
  <div>
    <multi-select-box
      :is-show-selected-len="true"
      :item-list="tags"
      @selectedChange="(key, value) => { this[key] = value }"
      parent-data-key="selectedTags"
      :parent-data="selectedTags"
      item-text-key="text"
      item-value-key="id"
      @subEvent="findTag"
      :size="size"
      :isImmediate="isImmediate"
      :placeholder="placeholder"
      :noDataText="noDataText"
      :noDataAll="true"
    ></multi-select-box>
  </div>
</template>

<script>
import TicketListUtil from '../../../util/ticket_list_util'
import PageType from '../../../enums/pageType'
import OptionType from '../../../enums/ticketListOptionType'
import MultiSelectBox from '../../../../../../views/agent/components/multiSelectBox'

export default {
  components: {MultiSelectBox},
  props: {
    updateSelectedTags: Function,
    brandId: Number,
    pageType: String,
    size: String,
    placeholder: {
      type: String,
      default: 'タグ検索',
      required: false
    }
  },
  data: () => ({
    color: '#fdf09e',
    selectedTags: [],
    loadingTags: false,
    tags: [],
    searchTag: [],
    tagOptions: [],
    isFirst: true,
    isImmediate: false,
    noDataText: '検索するタグを入力してください。'
  }),
  methods: {
    clearTag () {
      this.tags = []
    },
    remove (item) {
      const index = this.selectedTags.indexOf(item.id)
      if (index >= 0) this.selectedTags.splice(index, 1)
    },
    findTag (keyword) {
      if (keyword === null || keyword === undefined) return
      this.loadingCustomer = true

      this.axios.get(`/gateway/ticket/tags?keyword=${encodeURIComponent(keyword)}&brandId=${this.brandId}`)
        .then(res => {
          if (res.data.code === 0) {
            const data = res.data.data
            if (data.length === 0) {
              this.noDataText = '入力したタグには検索データがありません。'
            } else {
              this.noDataText = '検索するタグを入力してください。'
            }
            data.forEach(tag => {
              let item = {
                id: tag.id,
                text: tag.text
              }
              this.tags.push(item)
            })
          } else {
            this.$alertMsg(res.data.message)
          }
        })
        .catch(errorMsg => this.$alertMsg(errorMsg))
        .finally(() => {
          this.loadingCustomer = false
        })
    },
    resetAll () {
      this.selectedTags = []
    },
    setTagOption () {
      const data = TicketListUtil.parseJsonIntoOption(this.pageType, OptionType.TAG, localStorage.getItem('TICKET_LIST_OPTION'))
      let tagTemp = []

      data.forEach((item) => {
        tagTemp.push(item.id)
      })

      this.tags = data
      this.selectedTags = tagTemp
      if (this.selectedTags.length === 0) {
        this.isFirst = false
      }
    },
    setTagOptionData () {
      let tagTemp = []
      this.selectedTags.forEach((selectedItem) => {
        this.tags.some((tagItem) => {
          if (tagItem.id === selectedItem) {
            tagTemp.push(tagItem)
            return true
          }
        })
      })

      this.tagOptions = tagTemp
    }
  },
  watch: {
    searchTag (newVal) {
      newVal && newVal !== this.selectedTags && this.findTag(newVal)
    },
    'selectedTags.length' (val) {
      if (val >= 6) {
        this.$alertMsg('タグは最大5個まで検索できます。')
        this.selectedTags.splice(this.selectedTags.length - 1, 1)
      } else {
        if (!this.isFirst) {
          this.setTagOptionData()
          this.updateSelectedTags(this.selectedTags, this.tagOptions)
        }
        this.isFirst = false
      }
    }
  },
  mounted () {
    if (this.pageType !== PageType.DASHBOARD_PAGE) {
      this.setTagOption()
    } else {
      this.isFirst = false
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/menus/ticket/component/ticketlist/layout/tag_search_auto_complete.vue